import { ETPayButton } from '../../../../components/button';
import { Modal } from '../../../../components/modal';
import { Spinner } from '../../../../components/spinner';
import { ExportModalContent, ExportModalDescription, ExportModalTitle } from './styles';

interface ExportModalProps {
	title: string;
	isOpen: boolean;
	isLoading: boolean;
	retryError: boolean;
	closeError: boolean;
	onClose: () => void;
	linkExport: string;
	retryFunction?: () => void;
}

const ExportModal = ({
	title,
	isOpen,
	isLoading,
	retryError,
	closeError,
	onClose,
	linkExport,
	retryFunction,
}: ExportModalProps) => {
	const onExport = () => {
		if (linkExport) window.location.assign(linkExport);
		onClose();
	};

	const renderContent = () => {
		if (isLoading) return <Spinner />;
		else if (retryError)
			return (
				<ExportModalContent>
					<ExportModalTitle>Ha ocurrido un error al generar tu reporte.</ExportModalTitle>
					<ExportModalDescription>
						Porfavor, intenta nuevamente o comunicate con nuestro equipo de soporte.
					</ExportModalDescription>
					<ETPayButton title="Reintentar" variant="effect" onClick={retryFunction} />
				</ExportModalContent>
			);
		else if (closeError)
			return (
				<ExportModalContent>
					<ExportModalTitle>Ha superado el número de intentos</ExportModalTitle>
					<ExportModalDescription>
						Por favor, intenta nuevamente más tarde o comunícate con nuestro equipo de soporte.
					</ExportModalDescription>
					<ETPayButton title="Cerrar" variant="effect" onClick={onClose} />
				</ExportModalContent>
			);
		else {
			return (
				<ExportModalContent>
					<ExportModalTitle>Tu reporte está listo para descargar.</ExportModalTitle>
					<ExportModalDescription>
						¡Haz clic en el botón de abajo para descargar tu reporte de pagos!
					</ExportModalDescription>
					<ETPayButton
						title="Descargar reporte"
						variant="effect"
						onClick={onExport}
						disabled={linkExport === ''}
					/>
				</ExportModalContent>
			);
		}
	};
	return (
		<Modal title={title} show={isOpen} onClose={onClose} allowCloseModal={!isLoading} type="medium">
			{renderContent()}
		</Modal>
	);
};

export { ExportModal };
